module.exports = __webpack_public_path__ + "img/03.5bf22fc2.webp";